// @flow

import { all } from 'redux-saga/effects';
import * as types from '../actionTypes';
import { HitchpinApi } from '../../api/Hitchpin';
import {
  getMyWantedActions,
  getMyWantedListActions,
} from '../actions/myWanteds';
import * as schemata from '../schemata';
import genericFetcherSagas from './generic';
import { selectMyWanteds } from '../reducers/myWanteds';

export default function* (): Generator<any, void, any> {
  yield all([
    genericFetcherSagas(
      selectMyWanteds,
      getMyWantedListActions,
      getMyWantedActions,
      types.GET_MYWANTED_ASYNC.MANY,
      types.GET_MYWANTED_ASYNC.SINGLE,
      HitchpinApi.myWanteds,
      schemata.wanted,
    ),
  ]);
}
